import OAuthIntegration from './OAuthIntegration';

export default class GoogleIntegration extends OAuthIntegration {}
